var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex_col scroll"},[_c('StoreOptionButton',{attrs:{"selected":_vm.isParam},on:{"changeOption":_vm.getOptionState}}),_c('InspectionButton',{attrs:{"state":_vm.isParam}}),(_vm.isParam==='dash')?_c('InspectionDashBoard'):(_vm.isParam==='report')?_c('InspectionReport'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }